<template>
  <b-overlay :show="loading">
    <div v-if="!justificationCompleted && state === '9'">
      <div class="row mt-3" v-if="showJustificationInput">
        <div class="col-12">
          <vs-textarea
            label="Justificación de edición"
            class="w-100 mt-3"
            width="100%"
            v-model="justification"
            name="justification"
            height="100px"
            maxlength="900"
            counter="900"
            v-validate="{ required: state === '9', max: 2000 }"
            data-vv-as="justificación"
          />
          <div v-if="errors.first('metadata.justification')"
               class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
               style="height: 32px;">
          <span class="span-text-validation">
            {{errors.first('metadata.justification')}}
          </span>
          </div>
        </div>
        <div class="col-12 text-right">
          <vs-button
            v-tooltip="''"
            class="mr-2 btn btn-primary"
            @click="continueToEditMeta"
          >
            Continuar
          </vs-button>
        </div>
      </div>
    </div>
    <form
      autocomplete="off"
      @keydown.enter.prevent
      data-vv-scope="metadata"
      v-if="showForm && 'dnt' in detailsFile"
    >
      <b-card title="Metadata" class="mt-3">
        <h4 class="text-primary" v-if="!fromEdit">
          Si quieres editar los destinatarios y adjuntos, realiza las modificaciones
          antes en el modal a continuación y luego edita/completa
          la metadata de forma habitual.
        </h4>
        <b-modal
          v-if="!fromEdit"
          ref="modalMetadata"
          size="xl"
          hide-footer
          no-close-on-backdrop
          title="Metadata del expediente"
        >
          <DocumentProcessingMeta :notify="notify" @close-modal="closeModal" />
        </b-modal>
        <div class="row my-5" v-if="!fromEdit">
          <div class="col-12 text-left">
            <vs-button
              class="mr-2 btn btn-warning"
              @click="verDatos()"
              :disabled="loading"
            >
              Ver información
            </vs-button>
          </div>
        </div>
        <ReadOnlyMetaData v-if="!fromEdit" />
        <div
          class="row mt-3"
          v-if="getSenderFile !== 'conventional' && getSenderFile !== 'commission'"
        >
          <div class="col-4">
            <vs-input v-model="name" class="w-100" label="Nombre"/>
          </div>
          <div class="col-4">
            <vs-input v-model="address" class="w-100" label="Dirección"/>
          </div>
          <div class="col-4">
            <vs-input
              v-model="phone"
              class="w-100"
              label="Teléfono"
              placeholder="Escriba en formato +56912345678"
              data-vv-as="teléfono"
              v-validate="{ regex: phoneRegex }"
              name="phone"
              :danger="errors.has('metadata.phone')"
              :danger-text="errors.first('metadata.phone')"
              :success="!errors.has('metadata.phone') && phone.length > 0"
            />
          </div>
        </div>
        <div class="row mt-3" v-if="!fromEdit">
          <div class="col-6">
            <vs-input
              class="w-100"
              v-model="metadataDescription"
              label="Descripción"
              data-vv-as="descripción"
              name="alternativeTitle"
            />
          </div>
          <div class="col-6">
            <vs-input
              class="w-100"
              v-model="metadataAlternativeTitle"
              label="Título alternativo"
              data-vv-as="titulo alternativo"
              name="alternativeTitle"
            />
          </div>
          <div class="col-6 mt-3">
            <vs-input
              class="w-100"
              v-model="metadataIdentifierSaip"
              label="ID SAIP"
              data-vv-as="id Saip"
              name="idSaip"
            />
          </div>
          <div class="col-6 mt-3">
            <label>Fecha del documento</label>
            <b-form-datepicker
              locale="es"
              placeholder="Fecha del documento"
              name="documentDate"
              v-model="metadataDocumentDate"
              label-help="Puede usar las flechas del teclado y espacio"
            />
          </div>
          <div class="col-6 mt-3">
            <label>Fecha de finalización</label>
            <b-form-datepicker
              locale="es"
              placeholder="Fecha de finalización"
              name="documentEndDate"
              v-model="metadataDocumentEndDate"
              label-help="Puede usar las flechas del teclado y espacio"
            />
          </div>
          <div class="col-12 mt-3">
            <ListUser
              class="w-100 mb-0"
              autocomplete
              label="Autores internos"
              name="authors"
              data-vv-as="autores"
              onlyRol
              @full-user="addInternAuthor"
            />
          </div>
          <div class="col-5 mt-3">
            <vs-input
              class="w-100"
              v-model="metadata.externalAuthorName"
              label="Autores externos"
              data-vv-as="autores"
              name="authors"
            />
          </div>
          <div class="col-5 mt-3">
            <b-form-group label="Rol Autor externo">
              <v-select
                label="descripcion"
                :options="externAuthorsRoles"
                :reduce="rol => rol.valor"
                name="rolType"
                v-model="metadata.externalAuthorRol"
              />
            </b-form-group>
            <vs-input
              v-if="metadata.externalAuthorRol === 'Otro'"
              class="w-100"
              v-model="metadata.externalAuthorRolFree"
              label="Rol Autor externo"
              data-vv-as="autores"
              name="authors"
            />
          </div>
          <div class="col-2 mt-5">
            <vs-button class="mr-2 mt-5 btn btn-primary" @click="addExternalAuthor">
              Agregar
            </vs-button>
          </div>
          <div class="col-12 mt-3">
            <b-table-simple hover small v-if="metadata.internAuthors.length">
              <b-thead>
                <b-tr>
                  <b-th scope="col">Nombre</b-th>
                  <b-th scope="col">Rol</b-th>
                  <b-th scope="col" class="text-center">Acción</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr
                  v-for="internAuthor in metadata.internAuthors"
                  :key="internAuthor.id"
                >
                  <b-td>
                    <div class="d-flex align-items-center">
                      <vs-icon icon="person" size="medium" class="mr-1"/>
                      {{internAuthor['dc.contributor.name']}}
                    </div>
                  </b-td>
                  <b-td>
                    <vs-input readonly class="w-100" v-model="internAuthor['dc.contributor.type']"/>
                  </b-td>
                  <b-td class="text-center">
                    <vs-icon
                      class="cursor-pointer"
                      icon="remove_circle_outline"
                      size="small"
                      v-tooltip="'Eliminar'"
                      color="danger"
                      @click="removeMetadataAuthor('intern', internAuthor)"
                    />
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </div>
          <div class="col-6 mt-3">
            <b-form-group label="Unidad productora">
              <v-select
                label="label"
                :options="productionUnitOptions"
                :reduce="rol => rol.label"
                name="productionUnit"
                v-model="metadata.productionUnit"
              />
            </b-form-group>
          </div>
          <div class="col-6 mt-3" v-if="metadata.productionUnit === 'Otro'">
            <vs-input
              class="w-100"
              v-model="metadata.productionUnitOther"
              label="Unidad productora"
              data-vv-as="unidad productora"
              name="productionUnitOther"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
            <vs-input
              class="w-100"
              v-model="title"
              label="Título"
              data-vv-as="titulo"
              v-validate="'required'"
              name="title"
              :danger="errors.has('metadata.title')"
              :danger-text="errors.first('metadata.title')"
              :success="!errors.has('metadata.title') && title.length > 0"
            />
          </div>
          <div class="col-6">
            <ClassificationList
              :value="clasification"
              v-model="clasification"
            />
          </div>
          <div class="col-12 mb-2 mt-3">
            <label>Palabras clave</label>
            <Keywords v-model="keywords"/>
          </div>
          <div class="col-6">
            <label>Materia</label>
            <treeselect v-model="constitute" placeholder="Seleccione..." :options="ontology"/>
          </div>
          <div class="col-6">
            <div class="d-flex">
              <vs-input
                @keydown.enter.prevent="addRelation"
                class="w-100"
                placeholder="Escriba y presione enter"
                v-model="relation"
                label="Relación"
              />
              <vs-icon
                class="mt-5 pt-3 ml-2 cursor-pointer"
                icon="add_circle_outline"
                size="medium"
                v-tooltip="'Agregar relación'"
                color="success"
                @click="addRelation"
              />
            </div>
            <small class="text-danger"> {{relationError}} </small>
            <div class="mt-3 scrollNote" v-if="relations.length">
              <ul>
                <li class="mt-1" v-for="(currentRelation, index) in relations" :key="index">
                  <div class="d-flex align-items-center">
                    <div> {{`${index + 1}. ${currentRelation}`}} </div>
                    <vs-icon
                      class="ml-2 cursor-pointer"
                      icon="remove_circle_outline"
                      size="small"
                      v-b-tooltip.right="'Borrar relación'"
                      color="danger"
                      @click="removeRelation(currentRelation)"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-6 mt-3">
            <vs-input class="w-100" v-model="isPartOf" label="Es parte de"/>
          </div>
          <div class="col-6 mt-3">
            <label>Acceso</label>
            <b-form-select class="w-100" v-model="accessRights" :options="access"/>
          </div>
          <div class="col-6 mt-3">
            <div class="d-flex">
              <vs-input
                v-model="note"
                class="w-100"
                placeholder="Escriba y presione enter"
                label="Nota del archivero"
                @keydown.enter.prevent="addNote"
              />
              <vs-icon
                class="mt-5 pt-3 ml-2 cursor-pointer"
                icon="add_circle_outline"
                size="medium"
                v-tooltip="'Agregar nota'"
                color="success"
                @click="addNote"
              />
            </div>
            <small class="text-danger"> {{noteError}} </small>
            <div class="mt-3 scrollNote" v-if="notes.length">
              <ul>
                <li class="mt-1" v-for="(currentNote, index) in notes" :key="index">
                  <div class="d-flex align-items-center">
                    <div> {{`${index + 1}. ${currentNote}`}} </div>
                    <vs-icon
                      class="ml-2 cursor-pointer"
                      icon="remove_circle_outline"
                      size="small"
                      v-b-tooltip.right="'Borrar nota'"
                      color="danger"
                      @click="removeNote(currentNote)"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-6 mt-3">
            <label>Lengua o idioma</label>
            <b-form-select
              value-field="label"
              text-field="label"
              class="w-100" v-model="language" :options="languageOptions" @change="addLanguage"/>
            <small class="text-danger"> {{langError}} </small>
            <div class="mt-3 scrollNote" v-if="languages.length">
              <ul>
                <li class="mt-1" v-for="(currentLang, index) in languages" :key="index">
                  <div class="d-flex align-items-center">
                    <div> {{`${index + 1}. ${currentLang}`}} </div>
                    <vs-icon
                      class="ml-2 cursor-pointer"
                      icon="remove_circle_outline"
                      size="small"
                      v-b-tooltip.right="'Borrar'"
                      color="danger"
                      @click="removeLang(currentLang)"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-6 mt-3" v-if="language === 'Otro'">
            <vs-input
              class="w-100"
              label="Lenguaje"
              v-model="otherLanguage"
              placeholder="Escriba la lengua o idioma"
              data-vv-as="idioma"
              v-validate="'required'"
              name="language"
              :danger="errors.has('metadata.language')"
              :danger-text="errors.first('metadata.language')"
              :success="!errors.has('metadata.language') && otherLanguage.length > 0"
            />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-12 mt-5 text-right">
            <vs-button
              v-tooltip="''"
              class="mr-2 btn btn-primary"
              @click="goBack"
            >
              Volver
            </vs-button>
            <vs-button
              v-tooltip="''"
              class="mr-2 btn btn-success"
              @click="save"
            >
              Guardar
            </vs-button>
          </div>
        </div>
      </b-card>
    </form>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Treeselect from '@riophae/vue-treeselect';
import { uuid } from 'vue-uuid';

import Keywords from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/Keywords';
import Languages from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Languages';
import Access from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Access';
import Ontology from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/Ontology';
import ClassificationList from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/ClassificationList';
import ReadOnlyMetaData from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/ReadOnlyMetaData';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ProductionUnits from '@/febos/chile/dnt/components/wizard/companies/60100003-2/utils/ProductionUnits';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import InputProps from '@/febos/chile/dnt/components/wizard/companies/60100003-2/mixins/InputProps';
import DocumentProcessingMeta from '@/febos/chile/dnt/components/wizard/companies/60100003-2/components/DocumentProcessingMeta';

export default {
  name: 'Metadata',
  props: {
    notify: {
      default: () => {}
    },
    fromEdit: {
      type: Boolean,
      default: false
    },
    justificationCompleted: {
      type: Boolean,
      default: false
    }
  },
  mixins: [InputProps],
  components: {
    ClassificationList, ReadOnlyMetaData, Treeselect, Keywords, ListUser, DocumentProcessingMeta
  },
  data() {
    return {
      justification: '',
      error: {},
      state: '',
      // eslint-disable-next-line
      phoneRegex: /^[\+][0-9]{10,11}$/,
      ontology: Ontology,
      externAuthorsRoles: [],
      access: Access,
      language: 'Español',
      accessRights: 'public',
      otherLanguage: '',
      notes: [],
      note: null,
      noteError: '',
      langError: '',
      subjectError: '',
      relationError: '',
      languages: ['Español'],
      isPartOf: '',
      relation: '',
      relations: [],
      constitute: null,
      keywords: [],
      title: '',
      clasification: '',
      name: '',
      address: '',
      phone: '',
      metadataDescription: '',
      metadataAlternativeTitle: '',
      metadataIdentifierSaip: '',
      metadataDocumentDate: '',
      metadataDocumentEndDate: '',
      productionUnitOptions: ProductionUnits,
      metadata: {
        externalAuthorName: '',
        externalAuthorRol: '',
        externalAuthorRolFree: '',
        internAuthors: [],
        externalAuthors: [],
        productionUnit: '',
        productionUnitOther: ''
      }
    };
  },
  computed: {
    ...mapGetters('Dnts', ['detailsFile', 'loading']),
    languageOptions() {
      const languages = [...Languages];
      languages.sort((langA, langB) => {
        if (langA.label < langB.label) return -1;
        if (langA.label > langB.label) return 1;
        return 0;
      });
      return languages;
    },
    isPaper() {
      return this.inputFormat === 'paper';
    },
    getSenderFile() {
      let sender = '';
      const { compradorArea } = this.detailsFile.dnt;
      if (compradorArea === 'Ciudadano/a') sender = 'naturalPerson';
      if (compradorArea === 'Persona jurídica') sender = 'legalPerson';
      if (compradorArea === 'Organismo del estado') sender = 'stateAgency';
      if (compradorArea === 'Convencional') sender = 'conventional';
      if (compradorArea === 'Comisión') sender = 'commission';
      if (compradorArea === 'Usuario') sender = 'user';
      return sender;
    },
    showJustificationInput() {
      return this.state === '9' && this.detailsFile.dnt.solicitanteCodigo === 'si';
    },
    showForm() {
      if (this.fromEdit && this.state === '9') {
        return this.justificationCompleted;
      }
      return true;
    }
  },
  watch: {
    language(_, oldVal) {
      if (oldVal === 'Otro') this.otherLanguage = '';
    },
    detailsFile(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.loadData();
      }
    }
  },
  methods: {
    ...mapActions('Dnts', ['editConventionDnt', 'getFileDnt']),
    verDatos() {
      this.$refs.modalMetadata.show();
    },
    closeModal() {
      this.$refs.modalMetadata.hide();
      this.loadData();
    },
    loadData() {
      if (this.detailsFile && this.detailsFile.dnt) {
        this.clasification = this.detailsFile.dnt.categoria
          .split('-').slice(0, -1).join('-');
        this.name = this.detailsFile.dnt.despachoContactoNombre;
        this.address = this.detailsFile.dnt.despachoDireccion;
        this.phone = this.detailsFile.dnt.despachoContactoTelefono;
        this.state = this.detailsFile.dnt.estado;
      }

      const { metadata } = this.detailsFile;
      if (metadata) {
        metadata.forEach((field) => {
          if (field.nombre === 'title') {
            this.title = field.valor;
          }
          if (field.nombre === 'keywords') {
            this.keywords = JSON.parse(field.valor);
          }
          if (field.nombre === 'constitute') {
            this.constitute = field.valor;
          }
          if (field.nombre === 'relation') {
            this.relations = JSON.parse(field.valor);
          }
          if (field.nombre === 'isPartOf') {
            this.isPartOf = field.valor;
          }
          if (field.nombre === 'acceso') {
            this.accessRights = field.valor;
          }
          if (field.nombre === 'notes') {
            this.notes = JSON.parse(field.valor);
          }
          if (field.nombre === 'idioma') {
            this.languages = JSON.parse(field.valor);
          }
          if (field.nombre === 'dc.description') {
            this.metadataDescription = field.valor;
          }
          if (field.nombre === 'dc.title.alternative') {
            this.metadataAlternativeTitle = field.valor;
          }
          if (field.nombre === 'dc.identifier.SAIP') {
            this.metadataIdentifierSaip = field.valor;
          }
          if (field.nombre === 'dc.date.issued') {
            this.metadataDocumentDate = field.valor;
          }
          if (field.nombre === 'dc.date.fin') {
            this.metadataDocumentEndDate = field.valor;
          }
          if (field.nombre === 'dc.contributors') {
            this.metadata.internAuthors = JSON.parse(field.valor);
          }

          if (field.nombre === 'dc.publicher' && field.valor && field.valor !== '') {
            if (field.valor === 'Convención Constitucional') {
              this.metadata.productionUnit = field.valor;
            } else {
              this.metadata.productionUnit = 'Otro';
              this.metadata.productionUnitOther = field.valor;
            }
          }
        });
      }
    },
    goBack() {
      if (this.fromEdit) {
        this.$emit('close-modal');
      } else {
        this.$router.push({ name: 'files', params: { view: 'completitudDatos' } });
      }
    },
    getSenderValue() {
      let sender = '';
      const { compradorArea } = this.detailsFile.dnt;
      if (compradorArea === 'Ciudadano/a') sender = 'naturalPerson';
      if (compradorArea === 'Persona jurídica') sender = 'legalPerson';
      if (compradorArea === 'Organismo del estado') sender = 'stateAgency';
      if (compradorArea === 'Convencional') sender = 'conventional';
      if (compradorArea === 'Comisión') sender = 'commission';
      if (compradorArea === 'Usuario') sender = 'user';
      return sender;
    },
    getFlow() {
      const sender = this.getSenderValue();
      const INPUT = 1; // Cuando el documento es de entrada va 1
      const OUTPUT = 2; // Cuando el documento es de entrada pero es convencional
      if (sender === 'conventional' || sender === 'commission' || sender === 'user') {
        return OUTPUT;
      }
      return INPUT;
    },
    continueToEditMeta() {
      this.$emit('is-justified', this.justification);
    },
    async save() {
      const isValid = await this.$validator.validateAll('metadata');
      if (!isValid) return;
      if (this.otherLanguage) this.languages.push(this.otherLanguage);
      if (this.metadata.productionUnit === 'Otro' && !this.metadata.productionUnitOther) {
        this.notify('Por favor completa el campo de unidad productora', 'danger', 'Ups!');
        return;
      }
      const metadata = [
        { nombre: 'justification', tipo: 1, valor: this.justification },
        { nombre: 'title', tipo: 1, valor: this.title },
        { nombre: 'notes', tipo: 2, valor: JSON.stringify(this.notes) },
        { nombre: 'idioma', tipo: 2, valor: JSON.stringify(this.languages) },
        { nombre: 'acceso', tipo: 1, valor: this.accessRights },
        { nombre: 'isPartOf', tipo: 1, valor: this.isPartOf },
        { nombre: 'relation', tipo: 2, valor: JSON.stringify(this.relations) },
        { nombre: 'constitute', tipo: 1, valor: this.constitute },
        { nombre: 'keywords', tipo: 2, valor: JSON.stringify(this.keywords) },
        { nombre: 'dc.description', tipo: 1, valor: this.metadataDescription },
        { nombre: 'dc.title.alternative', tipo: 1, valor: this.metadataAlternativeTitle },
        { nombre: 'dc.identifier.SAIP', tipo: 1, valor: this.metadataIdentifierSaip },
        { nombre: 'dc.date.issued', tipo: 1, valor: this.metadataDocumentDate },
        { nombre: 'dc.date.fin', tipo: 1, valor: this.metadataDocumentEndDate },
        { nombre: 'dc.contributors', tipo: 2, valor: JSON.stringify(this.metadata.internAuthors) },
        {
          nombre: 'dc.publicher',
          tipo: 1,
          valor: this.metadata.productionUnit === 'Otro'
            ? this.metadata.productionUnitOther : this.metadata.productionUnit
        }
      ];
      const dnt = { ...this.detailsFile.dnt };
      if (this.title) {
        dnt.nombreDescriptivo = this.title;
      }
      dnt.solicitanteCodigo = 'si';
      dnt.categoria = `${this.clasification}-${this.getFlow()}`;
      dnt.despachoContactoNombre = this.name;
      dnt.emisorContactoNombre = this.name;
      dnt.despachoDireccion = this.address;
      dnt.despachoContactoTelefono = this.phone;
      dnt.emisorContactoTelefono = this.phone;

      const toSave = {
        adjuntos: this.detailsFile.adjuntos,
        detalles: this.detailsFile.detalles,
        dnt,
        observaciones: this.detailsFile.observaciones,
        destinatarios: this.detailsFile.destinatarios,
        metadata,
        dntDocDigitalAutores: this.detailsFile.docDigitalAutores,
        dntDocDigitalParticipantes: this.detailsFile.docDigitalParticipantes
      };

      await this.editConventionDnt(toSave);
      this.notify('Se ha guardado la metadata', 'success');
      if (this.fromEdit) {
        await this.getFileDnt({
          febosId: this.$route.query.febosId,
          retornarDnt: 'si',
          metadata: 'si',
          adjuntos: 'si',
          destinatarios: 'si',
          referencias: 'si',
          docDigitalAutores: 'si',
          docDigitalParticipantes: 'si'
        });
        this.loadData();
        this.$emit('close-modal');
      } else {
        await this.$router.push({ name: 'files', params: { view: 'completitudDatos' } });
      }
    },
    addNote() {
      this.noteError = '';
      if (this.notes.includes(this.note)) {
        this.noteError = 'La nota ya existe';
        return;
      }
      if (!this.note) {
        this.noteError = 'Hay que agregar una nota';
        return;
      }
      this.notes.push(this.note);
      this.note = '';
    },
    removeNote(noteToBeRemoved) {
      this.notes = this.notes.filter((note) => note !== noteToBeRemoved);
    },
    addRelation() {
      this.relationError = '';
      if (this.relations.includes(this.relation)) {
        this.relationError = 'La ralación ya existe';
        return;
      }
      if (!this.relation) {
        this.relationError = 'Hay que agregar una relación';
        return;
      }
      this.relations.push(this.relation);
      this.relation = '';
    },
    removeRelation(relationToBeRemoved) {
      this.relations = this.relations.filter((relation) => relation !== relationToBeRemoved);
    },
    addLanguage() {
      this.langError = '';
      if (this.language === 'Otro') {
        this.languages = [];
        return;
      }
      if (this.languages.includes(this.language)) {
        this.langError = 'El idioma ya existe';
        return;
      }
      this.languages.push(this.language);
    },
    removeLang(language) {
      this.languages = this.languages.filter((lang) => lang !== language);
    },
    addInternAuthor(user) {
      const existingAuthor = this.metadata.internAuthors
        .find((author) => author.id === user.id);
      if (existingAuthor) {
        this.notify('El autor ya existe', 'danger', 'Ups!');
        return;
      }

      const mappedUser = {
        id: user.id,
        'dc.contributor.name': user.label,
        'dc.contributor.type': user.rol
      };
      this.metadata.internAuthors.push(mappedUser);
    },
    addExternalAuthor() {
      if (!this.metadata.externalAuthorName || !this.metadata.externalAuthorRol) {
        this.notify('Completa los datos para poder agregar el autor', 'danger', 'Ups!');
        return;
      }
      if (this.metadata.externalAuthorRol === 'Otro' && !this.metadata.externalAuthorRolFree) {
        this.notify('Completa los datos para poder agregar el autor', 'danger', 'Ups!');
        return;
      }
      const mappedUser = {
        id: uuid.v1(),
        'dc.contributor.name': this.metadata.externalAuthorName,
        'dc.contributor.type': this.metadata.externalAuthorRol === 'Otro'
          ? this.metadata.externalAuthorRolFree : this.metadata.externalAuthorRol
      };
      this.metadata.internAuthors.push(mappedUser);
      this.metadata.externalAuthorName = '';
      this.metadata.externalAuthorRol = '';
    },
    removeMetadataAuthor(type, author) {
      if (type === 'intern') {
        this.metadata.internAuthors = this.metadata.internAuthors
          .filter((user) => user.id !== author.id);
      } else {
        this.metadata.externalAuthors = this.metadata.externalAuthors
          .filter((user) => user.id !== author.id);
      }
    },
  },
  async created() {
    if (!this.fromEdit) {
      await this.getFileDnt({
        febosId: this.$route.query.febosId,
        retornarDnt: 'si',
        metadata: 'si',
        adjuntos: 'si',
        destinatarios: 'si',
        referencias: 'si',
        docDigitalAutores: 'si',
        docDigitalParticipantes: 'si'
      });
    }
    this.loadData();
    const response = await listOptions({
      grupoOpcion: 'roles-usuarios-convencion',
      deshabilitado: 'no'
    });
    this.externAuthorsRoles = response.data.opciones;
  }
};
</script>

<style scoped>
.scrollNote {
  max-height: 100px;
  overflow: auto;
  border: 1px solid rgb(190, 190, 190);
  border-radius: 5px;
  padding: 5px;
}
</style>
